import { injectIntl } from "react-intl";
import intlShape from "../../shapes/intlShape";
import { Button } from "../Form";

type Props = {
  intl: intlShape;
  onAssignDuplicate?: $TSFixMeFunction;
  onCloseDuplicate?: $TSFixMeFunction;
  onCreateDuplicate?: $TSFixMeFunction;
  duplicateTags?: {
    tag?: string;
    id?: number;
  }[];
};

export function InstrumentationDuplicateOneTag({
  intl,
  onCloseDuplicate,
  onCreateDuplicate,
  duplicateTags,
  onAssignDuplicate,
}: Props) {
  return (
    <div id="duplicate-instrumentation-message" className="space-after">
      {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
      {duplicateTags.length > 0 ? (
        <>
          {intl.formatMessage(
            { id: "instrumentation_assign.single_duplicate_modal_text" },
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            { tag: duplicateTags[0].tag },
          )}
          <div className="btn-group space-before">
            <Button
              id="assign-button"
              hero
              // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
              onClick={() => onAssignDuplicate({ tag: duplicateTags[0] })}
              text={intl.formatMessage({ id: "button.assign" })}
            />
            <Button
              id="create-button"
              hero
              // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | undefined' is not assigna... Remove this comment to see the full error message
              onClick={onCreateDuplicate}
              text={intl.formatMessage({ id: "button.create" })}
            />
            <Button
              id="cancel-button"
              // @ts-expect-error TS(2322) FIXME: Type '$TSFixMeFunction | undefined' is not assigna... Remove this comment to see the full error message
              onClick={onCloseDuplicate}
              text={intl.formatMessage({ id: "button.cancel" })}
            />
          </div>
        </>
      ) : null}
    </div>
  );
}

export default injectIntl(InstrumentationDuplicateOneTag);
